import { Login } from './postComponents/Login'
import { Route, Routes, Navigate } from 'react-router'
import NavBar from './postComponents/NavBar'
import FetchUser from './postComponents/FetchUser'
import { Home } from './postComponents/Home'
import Footer from './postComponents/Footer'
import { PrivacyPolicy } from './postComponents/PrivacyPolicy'
import { TermsOfService } from './postComponents/TermsOfService'
import { Settings } from './postComponents/Settings'
import { Calendar } from './postComponents/Calendar'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { useContext, Component } from 'react'
import { UserContext } from './providers/userProvider'

class ErrorBoundary extends Component {
  state = { error: null }
  static getDerivedStateFromError(error) { return { error } }
  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 4 }}>
          <Typography variant="h6" color="error">Something went wrong</Typography>
          <Typography variant="body2" sx={{ mt: 1, wordBreak: 'break-all' }}>
            {this.state.error.message}
          </Typography>
        </Box>
      )
    }
    return this.props.children
  }
}

const ProtectedRoute = ({ element }) => {
  const { user } = useContext(UserContext)
  return user.phoneNumber ? element : <Navigate to="/login" replace />
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: '#000000',
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          minHeight: '100vh',
        }}
      >
        <ErrorBoundary>
        <FetchUser>
          <Routes>
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute element={<Home />} />} />
            <Route
              path="/settings"
              element={<ProtectedRoute element={<Settings />} />}
            />
            <Route
              path="/calendar"
              element={<ProtectedRoute element={<Calendar />} />}
            />
          </Routes>
        </FetchUser>
        </ErrorBoundary>
      </Box>
      <Footer />
    </ThemeProvider>
  )
}

export default App
